import * as React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import ButtonPlayful from '@/components/ButtonPlayful';

function BrowserUsageTable() {
  // NOTE: I was originally going to make this toggleable, but it was just too confusing.
  const [mode] = React.useState('absolute');

  return (
    <Wrapper>
      <Table cellPadding={0} cellSpacing={0}>
        <thead>
          <tr>
            <th>Browser</th>
            <th>Global</th>
            <th>
              <Desktop>joshwcomeau.com</Desktop>
              <Mobile>Blog</Mobile>
            </th>
            <th style={{ width: '6rem' }}>Delta</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Chrome</td>
            <td>66.7%</td>
            <td>74.5%</td>
            <td>
              {mode === 'absolute' ? (
                <Plus>7.8%</Plus>
              ) : (
                <Positive>111.7%</Positive>
              )}
            </td>
          </tr>
          <tr>
            <td>Safari</td>
            <td>18.1%</td>
            <td>12.2%</td>
            <td>
              {mode === 'absolute' ? (
                <Minus>5.9%</Minus>
              ) : (
                <Negative>67.4%</Negative>
              )}
            </td>
          </tr>
          <tr>
            <td>Edge</td>
            <td>5.3%</td>
            <td>5.0%</td>
            <td>
              {mode === 'absolute' ? (
                <Minus>0.3%</Minus>
              ) : (
                <Negative>94.3%</Negative>
              )}
            </td>
          </tr>
          <tr>
            <td>Firefox</td>
            <td>2.7%</td>
            <td>6.8%</td>
            <td>
              {mode === 'absolute' ? (
                <Plus>4.1%</Plus>
              ) : (
                <Positive>251.9%</Positive>
              )}
            </td>
          </tr>
          <tr>
            <td>Opera</td>
            <td>2.2%</td>
            <td>0.9%</td>
            <td>
              {mode === 'absolute' ? (
                <Minus>1.3%</Minus>
              ) : (
                <Negative>40.9%</Negative>
              )}
            </td>
          </tr>
          <tr>
            <td>IE</td>
            <td>0.13%</td>
            <td>0.0%</td>
            <td>
              {mode === 'absolute' ? (
                <Minus>0.13%</Minus>
              ) : (
                <Negative>0%</Negative>
              )}
            </td>
          </tr>
          <tr>
            <td>Other</td>
            <td>4.87%</td>
            <td>0.6%</td>
            <td>
              {mode === 'absolute' ? (
                <Minus>4.27%</Minus>
              ) : (
                <Negative>12.3%</Negative>
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-inline: -14px;
  margin-bottom: 3rem;
  max-width: calc(100% + 16px * 2);
  overflow: auto;
`;

const Table = styled.table`
  width: 100%;

  th {
    text-align: left;
    font-weight: var(--font-weight-bold);
    font-size: 0.8125rem;
    text-transform: uppercase;
    color: var(--color-gray-700);
    padding: 6px 14px;
    border-bottom: 3px solid var(--color-gray-700);

    &:not(:first-of-type) {
      text-align: center;
    }
    &:not(:last-of-type) {
      border-right: 1px solid var(--color-gray-700);
    }
  }

  tr {
    position: relative;
  }

  tbody tr::after {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0px;
    right: 0;
    bottom: 0;
    background: var(--color-gray-100);
    pointer-events: none;
    opacity: 0;
    transition: opacity 200ms;
  }

  tbody tr:hover::after {
    opacity: 0.6;
  }

  tbody td:last-of-type {
    /* text-align: center; */
  }

  td {
    font-size: 0.9375rem;
    padding: 14px;
    border-bottom: 1px solid var(--color-gray-200);

    &:first-of-type {
      font-weight: var(--font-weight-medium);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      a {
        color: var(--color-primary);
        text-decoration: none;
      }
    }

    &:not(:first-of-type) {
      text-align: center;
    }

    &:not(:last-of-type) {
      border-right: 1px solid var(--color-gray-200);
    }
  }
`;

const Delta = styled.span`
  font-weight: var(--font-weight-bold);
  margin-left: 0.25em;
`;
const Plus = styled(Delta)`
  color: var(--color-success);
  &::before {
    content: '+';
  }
`;
const Minus = styled(Delta)`
  color: var(--color-error);
  &::before {
    content: '-';
  }
`;
const Positive = styled(Plus)`
  &::before {
    content: '×';
  }
`;
const Negative = styled(Minus)`
  &::before {
    content: '×';
  }
`;

const Desktop = styled.span`
  @media ${BREAKPOINTS.smAndSmaller} {
    display: none;
  }
`;
const Mobile = styled.span`
  @media ${BREAKPOINTS.smAndLarger} {
    display: none;
  }
`;

const ToggleButton = styled(ButtonPlayful)`
  margin: 32px auto 0;
`;

export default BrowserUsageTable;
